import { traceWithValue } from '@macs-frontend/core/utils/debug';
import { environment } from '@macs-frontend/env';
import * as fromRouter from '@ngrx/router-store';
import {
  ActionReducer,
  ActionReducerMap,
  createSelector,
  MetaReducer,
} from '@ngrx/store';
import {
  loaderInProgressTypesSelector,
  loaderReducer,
  LoaderState,
  loaderVisibleSelector,
} from './loader.reducer';
import { metaReducer, MetaState } from './meta';

export interface State {
  router: fromRouter.RouterReducerState;
  meta: MetaState;
  loader: LoaderState;
}

export const reducers: ActionReducerMap<State> = {
  router: fromRouter.routerReducer,
  meta: metaReducer,
  loader: loaderReducer,
};

// eslint-disable-next-line functional/no-let
let logStateSlices: undefined | null | string[];

export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  // @ts-expect-error
  // eslint-disable-next-line sonarjs/cognitive-complexity
  return function (state: State, action: any): State {
    // eslint-disable-next-line functional/no-let
    let result;
    const startTime = Date.now();
    try {
      result = reducer(state, action);
    } catch (error) {
      console.groupCollapsed(action.type);
      traceWithValue('prev state')(state);
      traceWithValue('action')(action);
      console.log('error', error);
      console.groupEnd();

      throw error;
    }

    console.groupCollapsed(action.type);
    traceWithValue('prev state')(state);
    traceWithValue('action')(action);
    console.log(new Error('show trace'));
    traceWithValue('next state')(result);
    traceWithValue('time')(Date.now() - startTime);
    console.groupEnd();

    if (logStateSlices === undefined) {
      if (localStorage.getItem('logStateSlices')) {
        logStateSlices = String(localStorage.getItem('logStateSlices')).split('|');
      } else {
        logStateSlices = null;
      }
    }

    if (logStateSlices) {
      for (const path of logStateSlices) {
        if (state && result) {
          // eslint-disable-next-line functional/no-let
          let before;
          // eslint-disable-next-line functional/no-let
          let after;
          try {
            // eslint-disable-next-line no-eval
            before = eval('state' + path);
          } catch (e) {}
          try {
            // eslint-disable-next-line no-eval
            after = eval('result' + path);
          } catch (e) {}

          if (before !== after) {
            console.log(path + ':', before, ' -> ', after);
          }
        }
      }
    }

    return result;
  };
}

export const metaReducers: MetaReducer<State>[] = !environment.production ? [logger] : [];

export const loaderStateSelector = (state: State) => state.loader;
export const loaderActiveSelector = createSelector(
  loaderStateSelector,
  loaderVisibleSelector,
);

export const loaderInProgressSelector = createSelector(
  loaderStateSelector,
  loaderInProgressTypesSelector,
);
